import FluxUtils from 'flux/utils';

import PageNotFound404ErrorPage from 'sharedreact/components/PageNotFound404ErrorPage';
import asFunctional from 'sharedreact/components/asFunctional';
import SettingsStore from 'sharedreact/stores/SettingsStore';

type State = ConstructorParameters<typeof PageNotFound404ErrorPage>[0];

function getStores () {
  return [
    SettingsStore
  ];
}

function calculateState (prevState?: State): State {
  return {
    language: SettingsStore.getLanguage()
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(PageNotFound404ErrorPage),
  getStores,
  calculateState
);
